import { Box, Button, SpaceBetween } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';
import { externalLinks } from '../../../data/externalLinks';
import { featureIsEnabled, useFeatures } from '../../../hooks/features';
import { useSearchParams } from 'react-router-dom';
import { EVENT_CREATION } from '../../../utils/constants';

export interface NoActivitiesViewComponentProps {
  analyticsPrefix: string;
}

export function NoActivitiesViewComponent(props: NoActivitiesViewComponentProps) {
  const { t } = useTranslation(['activity', 'translation']);
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const isEventCreationEnabled = featureIsEnabled(EVENT_CREATION, features, searchParams);

  return (
    <Box textAlign="center">
      <SpaceBetween direction="vertical" size="s">
        <b className="pseudoHeader">{t('coordinatorEventShiftsList.noActivities')}</b>
        <div>
          <div>{t('coordinatorEventShiftsList.noActivitiesSubtitle1')}</div>
          <div>{t('coordinatorEventShiftsList.noActivitiesSubtitle2')}</div>
          <div>{t('coordinatorEventShiftsList.noActivitiesSubtitle3')}</div>
        </div>

        <Button
          variant={isEventCreationEnabled ? 'normal' : 'primary'}
          external={isEventCreationEnabled}
          data-aci-analytics-name={props.analyticsPrefix + '_planEventLink'}
          target="_blank"
          href={externalLinks.support.planningPlaybooks}
        >
          {t('coordinatorEventShiftsList.planAnEvent')}
        </Button>
      </SpaceBetween>
    </Box>
  );
}
